import { renderColumn } from 'components/TableColumn/TableColumn';
import { OutdoorCreativeListDataProvider } from './OutdoorCreativeListDataProvider';
import i18n from 'i18n';
import {
  commonColumnSetting,
  CreativeListCommonColumns
} from './CreativeListCommonColumnData';
import { getChannelGroupIdOfCreative } from './CreativeListFormatters';
import {
  formatEpaperDuration,
  usesEpaperDurationFormat
} from 'core/channelGroup/EpaperChannelGroup';

enum COLUMNS {
  OUTDOOR_TYPE = 'outdoorType',
  DURATION = 'duration'
}

export class DynamicOutdoorCreativeListDataProvider extends OutdoorCreativeListDataProvider {
  getColumns() {
    const columns = super.getColumns();
    const approvalColumn = renderColumn(
      commonColumnSetting[CreativeListCommonColumns.APPROVAL],
      this.formatters.approvalFormatter
    );
    const approvalColumnIndex =
      columns.findIndex(
        (column) => column.dataField === CreativeListCommonColumns.PREVIEW
      ) + 1;
    columns.splice(approvalColumnIndex, 0, approvalColumn);
    const durationColumn = columns.find(
      (column) => column.dataField === COLUMNS.DURATION
    );
    if (durationColumn) {
      // 動態渠道的秒數由廣告活動類型設定，不是 outdoorForm.labels.durationN 那幾個固定
      // 選項，照那條 key 對照會把 key 本身印在列表上。
      durationColumn.formatter = (duration, creative: any) =>
        usesEpaperDurationFormat(
          getChannelGroupIdOfCreative(creative),
          creative.outdoorType
        )
          ? formatEpaperDuration(duration)
          : `${duration} ${i18n.t('common.units.seconds')}`;
    }
    return columns;
  }
}
